// Sort cart items: Drago Roller first, then Hand Wraps, then Deodorizers, then anything else.
// Idempotent: returns early if items are already in the right order, so the
// MutationObserver below doesn't trigger an infinite loop.
window.dragoSortCartItems = function () {
  var order = {
    'drago-roller': 1,
    'drago-hand-wraps': 2,
    'drago-glove-deodorizers': 3
  };
  function priority(el) {
    var link = el.querySelector('a[href*="/products/"]');
    var href = link ? (link.getAttribute('href') || '') : '';
    for (var slug in order) {
      if (href.indexOf('/' + slug) >= 0) return order[slug];
    }
    return 99;
  }
  var containers = document.querySelectorAll('cart-drawer-items, #CartDrawer-CartItems, .cart-items tbody');
  containers.forEach(function (c) {
    var items = Array.prototype.slice.call(c.querySelectorAll('.cart-item'));
    if (items.length < 2) return;
    var sorted = items.slice()
      .map(function (item, idx) { return { item: item, idx: idx, p: priority(item) }; })
      .sort(function (a, b) { return a.p === b.p ? a.idx - b.idx : a.p - b.p; })
      .map(function (e) { return e.item; });
    var alreadyOrdered = true;
    for (var i = 0; i < sorted.length; i++) {
      if (items[i] !== sorted[i]) { alreadyOrdered = false; break; }
    }
    if (alreadyOrdered) return;
    sorted.forEach(function (item) { item.parentElement.appendChild(item); });
  });
};

// ============================================================================
// Roller VISUAL merge.
// The "50% off 1 wrap with Roller" discount is a Buy-X-Get-Y promo. Shopify tags
// exactly one roller unit as the discount "trigger", which forces the roller into
// two separate cart lines (trigger vs regular) whenever there are 2+ rollers plus
// wraps. Those lines have different discount allocations, so Shopify physically
// cannot keep them on one line. A forced /cart/update merge gets re-split on the
// next recalculation. So instead of fighting the server, we collapse the lines in
// the DOM: show one "Drago Roller" row with the combined quantity and price, hide
// the duplicates, and drive the quantity buttons through our own handler.
// ============================================================================
var DRAGO_ROLLER_VARIANT_ID = 45448764850366;

function dragoParseMoney(text) {
  if (!text) return null;
  var m = text.match(/-?[\d.,]+/);
  if (!m) return null;
  var num = m[0];
  var lastDot = num.lastIndexOf('.');
  var lastComma = num.lastIndexOf(',');
  var sep = '.';
  if (lastComma > lastDot) { sep = ','; num = num.replace(/\./g, '').replace(',', '.'); }
  else { num = num.replace(/,/g, ''); }
  return { amount: parseFloat(num), sep: sep, template: text };
}
function dragoFormatMoney(amount, template, sep) {
  if (!isFinite(amount)) return template;
  var f = amount.toFixed(2).replace('.', sep);
  return template.replace(/-?[\d.,]+/, f);
}
function dragoRollerRows(container) {
  return Array.prototype.slice.call(container.querySelectorAll('.cart-item')).filter(function (r) {
    if (r.classList.contains('drago-ghost')) return false;
    return !!r.querySelector('a[href*="/drago-roller"]');
  });
}

// Collapse 2+ roller rows into a single combined-display row. Idempotent: once a
// container is merged it early-returns, so our own DOM writes don't re-trigger it.
window.dragoMergeRollerDisplay = function () {
  // Disabled 2026-07-08. This "visual merge" collapsed split roller lines and
  // rewrote combined quantities/prices directly in the cart DOM. When a roller
  // split into two lines it could show a quantity that diverged from the real
  // Shopify cart, and its quantity buttons routed through dragoRollerAdjust (which
  // calls /cart/add), so a tap to "fix" the display silently added a real roller.
  // Customer report: 1 roller in cart became 2 at checkout. The cart now always
  // renders the true Shopify line items, so the cart matches checkout exactly.
};

window.dragoRollerAdjust = function () { /* disabled together with dragoMergeRollerDisplay above */ };

function dragoDrawerActive() {
  var d = document.querySelector('cart-drawer');
  return !!(d && (d.classList.contains('active') || d.classList.contains('animate') || d.classList.contains('is-open') || d.classList.contains('open')));
}
function dragoInjectSection(id, html) {
  if (!html) return;
  var target = document.getElementById(id);
  if (!target) return;
  var tmp = document.createElement('div');
  tmp.innerHTML = html;
  var fresh = tmp.querySelector('#' + id) || tmp.firstElementChild;
  if (fresh) target.innerHTML = fresh.innerHTML;
}
function dragoRenderCart(data) {
  if (!data) return;
  var drawer = document.querySelector('cart-drawer');
  if (drawer && dragoDrawerActive() && typeof drawer.renderContents === 'function' && data.sections && data.sections['cart-drawer']) {
    drawer.renderContents(data);
    return;
  }
  if (document.getElementById('main-cart-items') && data.sections && data.sections['main-cart-items']) {
    dragoInjectSection('main-cart-items', data.sections['main-cart-items']);
    dragoInjectSection('main-cart-footer', data.sections['main-cart-footer']);
    var bubble = data.sections['cart-icon-bubble'];
    if (bubble) { var bt = document.getElementById('cart-icon-bubble'); if (bt) { var t = document.createElement('div'); t.innerHTML = bubble; var f = t.querySelector('#cart-icon-bubble') || t.firstElementChild; if (f) bt.innerHTML = f.innerHTML; } }
    window.dragoSortCartItems();
    window.dragoMergeRollerDisplay();
    return;
  }
  if (drawer && typeof drawer.renderContents === 'function' && data.sections && data.sections['cart-drawer']) {
    drawer.renderContents(data);
    return;
  }
  location.reload();
}

(function () {
  var busy = false, timer = null;
  function pass() {
    if (busy) return;
    busy = true;
    try {
      window.dragoSortCartItems();
      window.dragoMergeRollerDisplay();
      lockQtyInputs();
    } finally {
      busy = false;
    }
  }
  // Quantity number is display-only on mobile (CSS blocks the tap); also suppress the
  // on-screen keyboard as a backup so a value can never be typed in.
  function lockQtyInputs() {
    var inputs = document.querySelectorAll('cart-drawer .quantity__input, #main-cart-items .quantity__input, .cart-items .quantity__input');
    for (var i = 0; i < inputs.length; i++) { inputs[i].setAttribute('inputmode', 'none'); }
  }
  // Run the sort/merge SYNCHRONOUSLY in the observer's microtask so the re-order
  // happens before the browser paints the re-rendered cart. The old setTimeout let
  // the server-order layout paint for one frame first (hand wraps flashing to the
  // top). pass()'s idempotency + busy flag stop any re-trigger loop.
  function debounced() { pass(); }

  // Observe the PERSISTENT elements (cart-drawer, #main-cart-items). Their innerHTML
  // is replaced on every re-render but the elements themselves are never removed, so
  // a single observer keeps working forever. Earlier observers attached to the inner
  // items list died the first time the theme swapped that element out.
  function attach() {
    document.querySelectorAll('cart-drawer, #main-cart-items').forEach(function (el) {
      if (el.__dragoObserved) return;
      el.__dragoObserved = true;
      new MutationObserver(debounced).observe(el, { childList: true, subtree: true });
    });
  }

  // Intercept clicks on the merged roller row's quantity / remove controls in the
  // capture phase so the theme's own line-bound handler never runs (it would split
  // the rollers again). We re-route to our combined-quantity handler.
  document.addEventListener('click', function (e) {
    var row = e.target.closest && e.target.closest('.cart-item[data-drago-roller-merged]');
    if (!row) return;
    var removeCtl = e.target.closest('cart-remove-button, .cart-item__remove, .button--remove');
    var qtyBtn = e.target.closest('.quantity__button, button[name="plus"], button[name="minus"]');
    if (!removeCtl && !qtyBtn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    // Show the theme's native per-item spinner on the roller row (matches every
    // other cart item). The re-render clears it.
    var sp = row.querySelector('.loading__spinner');
    if (sp) sp.classList.remove('hidden');
    if (removeCtl) { window.dragoRollerAdjust('remove'); return; }
    var name = qtyBtn.getAttribute('name');
    var isPlus = name === 'plus';
    var isMinus = name === 'minus';
    if (!isPlus && !isMinus) {
      var widget = qtyBtn.closest('.quantity, quantity-input, .cart-quantity, quantity-popover');
      var btns = widget ? widget.querySelectorAll('.quantity__button') : [];
      if (btns.length === 2) { isMinus = qtyBtn === btns[0]; isPlus = qtyBtn === btns[1]; }
    }
    if (isPlus) window.dragoRollerAdjust(1);
    else if (isMinus) window.dragoRollerAdjust(-1);
  }, true);

  function init() { pass(); attach(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('cart:updated', debounced);
  document.addEventListener('cart:refresh', debounced);
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('#cart-icon-bubble')) {
      setTimeout(function () { attach(); debounced(); }, 250);
    }
  });

  // Show a full-screen spinner the moment checkout is clicked, so the wait for the
  // Shopify checkout page to load has clear feedback. We do NOT preventDefault, so
  // the normal navigation proceeds. The spinner is wiped when the new page loads.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="checkout"], .cart__checkout-button, #checkout, a[href$="/checkout"], a[href*="/checkout?"]');
    if (!btn) return;
    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    // Go straight to /checkout using the REAL (server) cart. Do NOT let the theme
    // submit the cart form's updates[] on checkout. The page and the always-present
    // cart drawer each render their own set of name="updates[]" quantity inputs, and
    // the theme's checkout button is associated (via form=) with the drawer form.
    // That form can hold STALE or sort-REORDERED quantity values; Shopify applies
    // updates[] by POSITION, so submitting it overwrites the true cart and swaps
    // quantities between products at checkout (customer report: 2 deodorizers + 1
    // roller became 1 deodorizer + 2 rollers). Every quantity change is already
    // AJAX-saved server-side, so a plain redirect to /checkout is correct and safe.
    e.preventDefault();
    e.stopImmediatePropagation();
    if (typeof window.dragoShowCartLoading === 'function') window.dragoShowCartLoading({ fullscreen: true });
    window.location.href = '/checkout';
  }, true);

  // If the user clicks Checkout (full-screen spinner shows) then hits BACK, the page
  // is restored from the back/forward cache with that spinner still in the DOM, which
  // looks like an endless load. Clear any loading overlay whenever the page is shown
  // or restored (pageshow fires on bfcache restore with persisted=true).
  window.addEventListener('pageshow', function () {
    if (typeof window.dragoHideCartLoading === 'function') window.dragoHideCartLoading();
  });
  window.addEventListener('popstate', function () {
    if (typeof window.dragoHideCartLoading === 'function') window.dragoHideCartLoading();
  });
})();

// Loading overlay: a clean centered spinner. Defaults to covering the open cart
// drawer (upsell adds, roller quantity changes). Pass {fullscreen:true} for the
// checkout transition, or it auto-goes fullscreen when the drawer isn't open.
window.dragoShowCartLoading = function (opts) {
  try {
    if (document.querySelector('.drago-cart-loading')) return;
    var ov = document.createElement('div');
    ov.className = 'drago-cart-loading';
    if ((opts && opts.fullscreen) || !dragoDrawerActive()) {
      ov.className += ' drago-cart-loading--full';
    }
    ov.setAttribute('role', 'status');
    ov.setAttribute('aria-label', 'Loading');
    ov.innerHTML = '<span class="drago-cart-loading__spinner" aria-hidden="true"></span>';
    document.body.appendChild(ov);
  } catch (e) {
    console.warn('[Drago cartLoading]', e);
  }
};
window.dragoHideCartLoading = function () {
  document.querySelectorAll('.drago-cart-loading').forEach(function (n) { n.remove(); });
};

// Cart Upsell — Add-to-cart handler
window.dragoUpsellAdd = function (btn) {
  if (btn.disabled) return;
  var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
  if (!variantId) return;

  btn.disabled = true;
  var original = btn.textContent.trim();
  // 2026-10-22 (Shane: the Lace Converter add felt slow). Shopify takes about half
  // a second; show the result straight away instead of a full-drawer spinner, then
  // swap in the real cart when it lands.
  if (typeof window.dragoHideCartLoading === 'function') window.dragoHideCartLoading();
  btn.textContent = '✓ Added';
  btn.classList.add('is-added');
  var card = btn.closest('[data-upsell-card]');
  if (card) card.classList.add('is-adding');

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    })
  })
    .then(function (res) {
      if (!res.ok) return res.json().then(function (d) { throw d; });
      return res.json();
    })
    .then(function (data) {
      // Render the drawer, then run the sort + roller visual-merge passes. The
      // MutationObserver also fires on the render, so this is belt and suspenders.
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
        drawer.renderContents(data);
      }
      if (typeof window.dragoSortCartItems === 'function') window.dragoSortCartItems();
      if (typeof window.dragoMergeRollerDisplay === 'function') window.dragoMergeRollerDisplay();
      if (typeof window.dragoHideCartLoading === 'function') window.dragoHideCartLoading();
    })
    .catch(function (err) {
      console.error('[CartUpsell] Failed to add item:', err);
      btn.disabled = false;
      btn.textContent = original;
      btn.classList.remove('is-added');
      if (card) card.classList.remove('is-adding');
      if (typeof window.dragoHideCartLoading === 'function') window.dragoHideCartLoading();
    });
};

